import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createStore, applyMiddleware } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import rootReducer from './root-reducer';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'details'],
};

export default function setupStore(history) {
  const middlewares = applyMiddleware(thunk, routerMiddleware(history));
  const enhancer = composeWithDevTools({})(middlewares);
  const connectedReducer = connectRouter(history)(rootReducer);
  const persistedReducer = persistReducer(persistConfig, connectedReducer);
  const preloadedState = {};

  const store = createStore(persistedReducer, preloadedState, enhancer);
  const persistor = persistStore(store);

  return { store, persistor };
}



// WEBPACK FOOTER //
// ./src/store/index.js